module.exports = __webpack_public_path__ + "img/1.13857b5a.svg";